module.exports = __webpack_public_path__ + "static/media/DecNoaction.fba27f59.tsx";